export default "__VITE_ASSET__CF8_IWRP__"